// =============================================================================
// Copyright   : 2019 semantics GmbH
// Date        : $Date: 2019-11-27 22:47:49 +0100 (Wed, 27 Nov 2019) $
// Author      : Olli Powroznik, Tobias Schwarzkopf
// Worker      : $Author: o.powroznik $
// Revision    : $Rev: 105784 $
// Purpose     : slider widget implementation
// =============================================================================
// ---Third-party imports
import React from 'react'
import clsx from 'clsx'

// ---Framework imports
import {isDigit, strip} from 'ldash'
import log from 'uix/logging'
import {Sel} from 'uix/registries'
import {decodeAttribH5} from 'uix/utils'
import {useSelector, useState} from 'uix/hooks'

// ---Local imports
import HStyles from './banner.scss'
import {wcUrl} from './utils'

// ---Exports
export const BannerHandler = {
  match: ({tag}) => tag == 'Banner',
  build: ({attrib}) => {
    let {ids, ...props} = attrib
    props = decodeAttribH5(props)
    if (ids) {
      props.ids = ids
        .split(',')
        .map(e => strip(e))
        .filter(e => isDigit(e))
    }
    return <Banner {...props} />
  },
}

export const Banner = ({header, subheader, bgimage = 'banner_bg.jpg', ids = []}) => {
  let apiurl = useSelector(Sel.apiurl)
  let {dname} = useSelector(Sel.request)

  let [index, setIndex] = useState(0)
  let [transition, setTransition] = useState(false)
  let onClickBanner = () => {
    setIndex(Math.abs((index + 1) % ids.length))
    setTransition(true)
  }
  let transitionChange = () => {
    setTransition(false)
  }
  let url = `${wcUrl(apiurl, 800, ids[index])}`

  const bg = apiurl.href(`/${dname}/domainimage/${bgimage}`)

  let cssImgUrl = `${url}`

  const pageImg = {
    backgroundImage: cssImgUrl,
    height: '304px',
    width: 'auto',
  }

  const backgroundImg = {
    backgroundImage: 'url(' + bg + ')',
  }
  return (
    <div className={HStyles.sliderContainer} style={backgroundImg}>
      <div className={HStyles.overlayContainer}>
        <div className={HStyles.contentContainer}>
          <div className={HStyles.textArea}>
            <div className={HStyles.title}>{header}</div>
            <div className={HStyles.subtitle}>{subheader}</div>
          </div>
          <div style={{width: '400px', textAlign: 'center'}}>
            <img
              src={cssImgUrl}
              onClick={onClickBanner}
              onAnimationEnd={transitionChange}
              className={clsx(HStyles.page, transition && HStyles.faded)}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
